import type { ReactNode } from 'react'
import { MarketingHeader } from './MarketingHeader'
import { MarketingFooter } from './MarketingFooter'

export function MarketingShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <a href="#main" className="rl-skip-link">
        Skip to content
      </a>
      <MarketingHeader />
      {/* min-w-0: without it this flex item's automatic minimum width is
          its content's min-content size, so a wide child (e.g. the
          comparison table) forces the whole column wider than the
          viewport instead of scrolling inside its own overflow-x-auto
          wrapper -- see Home.tsx's comparison table. */}
      <main id="main" tabIndex={-1} className="min-w-0 flex-1 focus:outline-none">{children}</main>
      <MarketingFooter />
    </div>
  )
}
